import { Standard } from '@getvim/vim-connect';
import { encounterA, encounterB, encounterC, nonEditableAssessment } from '../encounters';

export const predefinedPayloads: Record<string, Standard.Events.EncounterUpdatedPayload> = {
  'Minnie Mouse - Encounter A': encounterA,
  'Steven Vazquez - Encounter B': encounterB,
  'Natasha Davies - Encounter C': encounterC,
  'Assessment not editable': nonEditableAssessment,
};
